import React, { useMemo } from "react";
import { AbsoluteCenter } from "../../AbsoluteCenter";
import { ButtonWithSound } from "../../AudioProvider";
import { useTranslation } from "react-i18next";
import infoIcon from "../../../assets/info.svg";
import { useScreenType } from "../../../hooks/useScreenType";

const PopupContainer = ({ children }: { children?: React.ReactNode }) => {
  const screenType = useScreenType();

  return (
    <div className="absolute bg-black-alpha-30 top-0 left-0 right-0 bottom-0 z-50">
      {screenType === "DESKTOP" ? (
        <AbsoluteCenter>{children}</AbsoluteCenter>
      ) : (
        <div className="flex justify-center items-center h-screen">
          {children}
        </div>
      )}
    </div>
  );
};

export const JoinTournamentErrorModal = ({
  error,
  onClose,
}: {
  error: string;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  const errorText = useMemo(() => {
    if (error.includes("insufficient funds")) {
      return (
        <p
          style={{
            fontSize: "20px",
            lineHeight: "30px",
            fontWeight: 500,
          }}
        >
          {t("insufficient_funds")}
        </p>
      );
    } else if (
      error.includes("User is already joined to non-completed tournament")
    ) {
      return (
        <>
          <p
            style={{
              fontSize: "20px",
              lineHeight: "30px",
              fontWeight: 500,
            }}
          >
            {t("instant_tournament.error_join.title")}
          </p>
          <p>{t("instant_tournament.error_join.description")}</p>
        </>
      );
    } else {
      return (
        <p
          style={{
            fontSize: "20px",
            lineHeight: "30px",
            fontWeight: 500,
          }}
        >
          {t("instant_tournament.full_tournament")}
        </p>
      );
    }
  }, [error]);

  return (
    <PopupContainer>
      <div
        style={{
          width: "420px",
          background: "linear-gradient(180deg, #306DAE 0%, #063358 100%)",
          border: "1px solid #1E71D3",
          borderRadius: "20px",
          padding: "60px 32px",
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, 0)",
        }}
        className="text-white flex flex-col items-center gap-3"
      >
        <img src={infoIcon} width={50} height={50} alt="Success" />
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-1 text-center">
            {errorText}
          </div>
          <ButtonWithSound
            className="btn-green-500 rounded-md shadow-xl text-white w-2/5 py-1 text-sm h-7"
            onClick={onClose}
          >
            {t("instant_tournament.error_join.action")}
          </ButtonWithSound>
        </div>
      </div>
    </PopupContainer>
  );
};
